import React from 'react';
import { useNavigate } from 'react-router-dom';

const About: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
    <div style={{
      minHeight: '100vh',
      background: '#f5f5f5',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
    }}>
    

      {/* Content */}
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '48px 24px'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '48px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
        }}>
          <h1 style={{
            fontSize: '36px',
            fontWeight: '700',
            color: '#1a3a52',
            marginBottom: '24px'
          }}>
            About PlotBuzz
          </h1>

          <p style={{
            fontSize: '18px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '32px'
          }}>
            PlotBuzz was built on one belief: <strong>kids write better when writing feels like play.</strong> We're a safe, gamified creative platform designed by a librarian who understands how to inspire imagination while protecting young creators online.
          </p>

          <h2 style={{
            fontSize: '28px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '48px',
            marginBottom: '16px'
          }}>
            Our Story
          </h2>

          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '24px'
          }}>
            PlotBuzz began in a public library, where our founder saw the same pattern every day: tweens loved stories, but writing tools felt like homework, and online spaces weren't built with child safety in mind. So we created something new — a writing game that finally competes with video games while building real literacy skills.
          </p>

          <div style={{
            background: '#F3F0FF',
            borderLeft: '4px solid #6C5CE7',
            padding: '24px',
            borderRadius: '8px',
            marginBottom: '32px'
          }}>
            <p style={{
              fontSize: '18px',
              fontStyle: 'italic',
              color: '#1a3a52',
              margin: 0,
              lineHeight: '1.6'
            }}>
              "PlotBuzz exists for the reluctant writer — the kid with big ideas who just needs a spark."
            </p>
            <p style={{
              fontSize: '14px',
              color: '#666',
              margin: '8px 0 0 0'
            }}>
              — Founder, PlotBuzz
            </p>
          </div>

          <h2 style={{
            fontSize: '28px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '48px',
            marginBottom: '16px'
          }}>
            Safety First
          </h2>

          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '32px'
          }}>
            Every story is screened through an advanced AI Safety Filter to keep the community free of bullying, hate speech, and inappropriate content.
          </p>

          <h2 style={{
            fontSize: '28px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '48px',
            marginBottom: '16px'
          }}>
            Writing as Play
          </h2>

          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '16px'
          }}>
            We motivate young authors with:
          </p>

          <ul style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginLeft: '24px',
            marginBottom: '32px'
          }}>
            <li style={{ marginBottom: '8px' }}>Daily Writing Streaks</li>
            <li style={{ marginBottom: '8px' }}>Collectible Scrib Cards</li>
            <li style={{ marginBottom: '8px' }}>Level Titles that show progress</li>
          </ul>

          <h2 style={{
            fontSize: '28px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '48px',
            marginBottom: '16px'
          }}>
            Built for Real Learning
          </h2>

          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '32px'
          }}>
            Our Premium AI Style Checks offer gentle, useful feedback to strengthen grammar, clarity, and vocabulary.
          </p>

          <h2 style={{
            fontSize: '28px',
            fontWeight: '700',
            color: '#1a3a52',
            marginTop: '48px',
            marginBottom: '16px'
          }}>
            Our Mission
          </h2>

          <p style={{
            fontSize: '16px',
            lineHeight: '1.8',
            color: '#333',
            marginBottom: '0'
          }}>
            To make writing irresistible. To give every child a safe, inspiring space to create. To help the next generation of storytellers grow with confidence.
          </p>

          {/* Related Pages */}
          <div style={{
            marginTop: '48px',
            paddingTop: '32px',
            borderTop: '1px solid #e5e5e5',
            textAlign: 'center'
          }}>
            <p style={{ fontSize: '14px', color: '#666', marginBottom: '16px' }}>
              More Information
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a href="/about" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>About</a>
              <a href="/privacy-policy" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</a>
              <a href="/terms-of-service" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>Terms of Service</a>
              <a href="/community-guidelines" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>Community Guidelines</a>
              <a href="/contact" style={{ color: '#6C5CE7', textDecoration: 'none', fontSize: '14px' }}>Contact Us</a>
            </div>
          </div>
        </div>  {/* ← closes white card */}
      </div>  {/* ← closes padding container */}
    </div>  {/* ← closes outer container */}
    </> 
  );
};

export default About;
